module.exports = __webpack_public_path__ + "static/media/Copywriting.50a95e86.svg";